import React from "react";
import authStorage from "../../utils/authStorage";
const Footer = () => {
	
	const currentYear = new Date().getFullYear();
	
    return (
<>
    <div className="dasboard-footer">
    ©&nbsp;{currentYear}, CONTINGENT FITNESS TRAINING, INC. All Rights Reserved.
    </div>
</>

)
}
export default Footer